import { useState } from 'react';
import type { ReceiptLine } from '../../../types/analyticstypes';

export default function ReceiptTab({ receipt }: { receipt?: ReceiptLine[] }) {
  const [showRaw, setShowRaw] = useState(false);

  if (!receipt || receipt.length === 0) {
    return (
      <div className="text-sm text-gray-500 italic p-6 text-center bg-gray-50 rounded-lg">
        No receipt captured for this transaction.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex gap-1 justify-end">
        <button
          onClick={() => setShowRaw(false)}
          className={`px-3 py-1 rounded-md text-xs font-medium ${
            !showRaw ? 'bg-blue-600 text-white' : 'text-gray-500 hover:bg-gray-100'
          }`}
        >
          Receipt
        </button>
        <button
          onClick={() => setShowRaw(true)}
          className={`px-3 py-1 rounded-md text-xs font-medium ${
            showRaw ? 'bg-blue-600 text-white' : 'text-gray-500 hover:bg-gray-100'
          }`}
        >
          Raw JSON
        </button>
      </div>

      {showRaw ? (
        <pre className="bg-gray-900 text-gray-100 text-[11px] p-4 rounded-lg overflow-x-auto max-h-[600px] font-mono">
          {JSON.stringify(receipt, null, 2)}
        </pre>
      ) : (
        <div className="flex justify-center">
          <div
            className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 font-mono text-[12px] leading-tight whitespace-pre"
            style={{ width: 'calc(45ch + 2rem)' }}
          >
            {receipt.map((line, i) => {
              const cls = [
                line.bold ? 'font-bold' : '',
                line.underline ? 'underline' : '',
                line.largeFont ? 'text-[14px]' : 'text-[12px]',
                line.centered ? 'text-center' : '',
                line.barcode ? 'bg-gray-100 my-1 rounded' : '',
              ]
                .filter(Boolean)
                .join(' ');
              const raw = line.barcode ? `|||| ${line.data} ||||` : line.data || ' ';
              const text = raw.length > 45 ? raw.slice(0, 45) : raw;
              return (
                <div key={i} className={cls || ''}>
                  {text}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
